import React from "react";
import toaster from 'toasted-notes';
import "./MessageHandler.css";

const Messages = {
    LOGIN_SUCCESS : "کد تایید برای شما ارسال شد",
    LOGIN_ERROR_400 : "مشکل در ورود اطلاعات",
    LOGIN_ERROR_500 : "سرور موقتا با مشکل مواجه شده",
    MOBILE_VALIDATION_ERROR : "شماره موبایل صحیح نمی باشد",
    VERIFY_TOKEN_ERROR : "کد تایید اشتباه می باشد",
    VERIFY_CODE_ERROR : "کد تایید اشتباه می باشد",
}




function Success(props) {
    return(
        <div className="success_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function Error(props) {

return(
    <div className="error_message-container">
        <span className="text-message">{props.message}</span>
    </div>
)
}


 function MessageHandler(message){
    switch (message.type) {
        case 'LOGIN':
            switch (message.status) {
                case 'SUCCESS':
                    toaster.notify(({ onClose }) => (<Success message={Messages.LOGIN_SUCCESS}/>), {duration: 2000});
                    break;
                case 'ERROR':
                    toaster.notify(({ onClose }) => (<Error   message={Messages.LOGIN_ERROR_400}/>),{duration: 2000});
                    break;
            }
            break;
        case 'VALIDATION' :
            switch (message.status) {
                    case 'MOBILE':
                    toaster.notify(({ onClose }) => (<Error   message={Messages.MOBILE_VALIDATION_ERROR}/>),{duration: 2000});
                    break;
                case 'VERIFY_TOKEN':
                    toaster.notify(({ onClose }) => (<Error   message={Messages.VERIFY_TOKEN_ERROR}/>),{duration: 2000});
                    break;
                case 'VERIFY_CODE':
                    toaster.notify(({ onClose }) => (<Error   message={Messages.VERIFY_CODE_ERROR}/>),{duration: 2000});
                    break;
            }
            break;
        default:
            toaster.notify(({ onClose }) => (<Error   message={Messages.LOGIN_ERROR_500}/>),{duration: 2000});
    }
}

export {MessageHandler};
